// @ts-nocheck
import React, { useState, useEffect } from "react";
import { Calendar, Switch } from "antd";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import ROUTES from "../../docRoutes/docRoutes";
import { FolderOpenOutlined, CheckSquareOutlined } from "@ant-design/icons";
import { useFetch } from "../../Services/useFetch";

const Dashboard = ({ children }) => {
  // redux containers of following user
  const { userInfo } = useSelector((state) => state.userDetails);

  // hooks initialization
  const [message, setMessage] = useState("");
  const [FolderSpace, setFolderSpace] = useState();
  const [permission, setPermission] = useState([]);
  const { request } = useFetch();

  // folder space
  const FolderFileSpace = async () => {
    try {
      const response = await request("/get-storage-details", "get", null, {
        "Content-Type": "application/x-www-form-urlencoded",
      });
      if (response?.data?.status === "1") {
        setFolderSpace(response?.data);
      }
    } catch (error) {}
  };

  const fetchBriefPermission = async () => {
    try {
      const formData = new URLSearchParams();
      formData.append("event_name", "is_view");
      formData.append("user_id", userInfo?.id);
      const response = await request("/briefcash-permission-list", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });
      if (response?.data?.status === "1") {
        setPermission(response?.data?.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (userInfo?.id) {
      fetchBriefPermission();
    }
  }, [userInfo?.id]);

  // calling each apis of dashboard which will render first
  useEffect(() => {
    FolderFileSpace();
  }, []);

  // dashboard message effects
  useEffect(() => {
    const currentHour = new Date().getHours();
    const morningStart = 6;
    const noonStart = 12;
    const eveningStart = 18;
    // Check the current time against the defined time segments
    if (currentHour >= morningStart && currentHour < noonStart) {
      setMessage(" Good Morning");
    } else if (currentHour >= noonStart && currentHour < eveningStart) {
      setMessage(" Good Afternoon");
    } else {
      setMessage(" Good Evening");
    }
  }, []);

  const storage = FolderSpace?.data;
  const numericStorage = parseFloat(storage?.replace("GB", "").trim());
  let totalStorage = 1000;
  const storageData = totalStorage - numericStorage;

  const usedPercentage = (numericStorage / totalStorage) * 100;

  return (
    <>
      <div className="bd_main" >
        {/* card section */}
        <div className="bd_herosection">
          <div className="container-fluid">
            <div className="bd_heading">
              <h1>{message} </h1>
              <p>{userInfo?.userfullname}</p>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "65px",
              }}
            >
              <div className="bd_diskSpace">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                    gap: "15px",
                    height: "60px",
                  }}
                >
                  <div
                    className="ant_icons"
                    style={{
                      background: "linear-gradient(to bottom right, #06b6d4, #3b82f6",
                      color: "white",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-hdd"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" />
                      <path d="M16 11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9.51c0-.418.105-.83.305-1.197l2.472-4.531A1.5 1.5 0 0 1 4.094 3h7.812a1.5 1.5 0 0 1 1.317.782l2.472 4.53c.2.368.305.78.305 1.198zM3.655 4.26 1.592 8.043Q1.79 8 2 8h12q.21 0 .408.042L12.345 4.26a.5.5 0 0 0-.439-.26H4.094a.5.5 0 0 0-.44.26zM1 10v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1" />
                    </svg>
                  </div>
                  <h2
                    style={{
                      marginTop: "9px",
                      fontWeight: "700",
                      fontSize: "22px",
                    }}
                  >
                    Server Disk
                  </h2>
                </div>

                {!FolderSpace?.data ? (
                  <p>Loading.....</p>
                ) : (
                  <div className="sliderStorage">
                    <div
                      style={{
                        width: `${usedPercentage}%`,
                        height: "100%",
                        backgroundColor: "#41A6EC",
                        borderRadius: "5px",
                        transition: "width 0.5s ease-in-out",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "14px",
                        color: "#333",
                        fontWeight: "bold",
                      }}
                    >
                      {`${numericStorage} / ${totalStorage} GB`}
                    </div>
                  </div>
                )}
              </div>

              <div className="bd_diskSpace hide-scrollbar">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                    gap: "15px",
                    height: "60px",
                  }}
                >
                  <div
                    className="ant_icons"
                    style={{
                      background: "linear-gradient(to bottom right,rgb(42, 207, 103), #22c55e",
                      color: "white",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-shield-fill-check"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.8 11.8 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7 7 0 0 0 1.048-.625 11.8 11.8 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.54 1.54 0 0 0-1.044-1.263 63 63 0 0 0-2.887-.87C9.843.266 8.69 0 8 0m2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793z"
                      />
                    </svg>
                  </div>
                  <h2
                    style={{
                      marginTop: "9px",
                      fontWeight: "700",
                      fontSize: "22px",
                    }}
                  >
                    Allow Permission
                  </h2>
                </div>
                {permission == [] ? (
                  <p>Loading.....</p>
                ) : (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      gap: "20px",
                    }}
                  >
                    {permission[0]?.is_add == 1 && (
                      <>
                        <div className="permission_div">
                          <p style={{ width: "130px" }}>Create / Add Files</p>
                          <CheckSquareOutlined fill style={{ color: "green", fontSize: "24px" }} />
                        </div>
                      </>
                    )}
                    {permission[0]?.is_update == 1 && (
                      <>
                        <div className="permission_div">
                          <p style={{ width: "130px" }}>Upload Files</p>
                          <CheckSquareOutlined fill style={{ color: "green", fontSize: "24px" }} />
                        </div>
                      </>
                    )}
                    {permission[0]?.is_download == 1 && (
                      <>
                        <div className="permission_div">
                          <p style={{ width: "130px" }}>Download Files</p>

                          <CheckSquareOutlined fill style={{ color: "green", fontSize: "24px" }} />
                        </div>
                      </>
                    )}
                    {permission[0]?.is_delete == 1 && (
                      <>
                        <div className="permission_div">
                          <p style={{ width: "130px" }}>Delete Folders / Files</p>
                          <CheckSquareOutlined fill style={{ color: "green", fontSize: "24px" }} />
                        </div>
                      </>
                    )}

                    {permission[0]?.is_rename == 1 && (
                      <>
                        <div className="permission_div">
                          <p style={{ width: "130px" }}>Rename Folders / Files</p>
                          <CheckSquareOutlined fill style={{ color: "green", fontSize: "24px" }} />
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {children}
      </div>
    </>
  );
};

export default Dashboard;
